import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import {SaveDataVariableMap} from "~/models/processFlows/steps/saveDataVariableMap";
import MappableStep from "~/models/processFlows/constructorMixins/mappableStep";
import {ProcessFlowStepType} from '../../../enums/processFlowStepType'
import {ISaveDataStep} from '~/interfaces/processFlowInterfaces'

export class ProcessFlowSaveDataStep extends MappableStep(ProcessFlowStep, SaveDataVariableMap) implements ISaveDataStep {
  step_type: ProcessFlowStepType.SaveData

  get defaultTitle(): string {
    return `Save data`
  }
}